import { Injectable } from "@angular/core";
import { ProtobufService } from "./protobuf.service";
import { OrderService } from "./order/order.service";
import { map, Observable } from "rxjs";
import { AITariff, AITariffType, CreateOrderRequest, GetAITariffProductsResponse } from "@proto/odoo/order";
import { SaleOrder } from "./buy/buy.model";


@Injectable({ providedIn: 'root' })
export class AiTariffService {

    constructor(private protoService: ProtobufService, private saleOrderService: OrderService) { }

    getTariffIdentifier(tariffTypeString: string): string {
        return tariffTypeString.slice(-1).toLowerCase();
    }

    getSpecificAITariff(tariffList: AITariff[] | undefined, tariffName: string | undefined): AITariff | undefined {
        if (!tariffList?.length || !tariffName) { return undefined; }
        const lastChar = tariffName.slice(-1).toUpperCase();
        const enumKey = `AITARIFF_TYPE_${lastChar}` as keyof typeof AITariffType;
        const tariffType = AITariffType[enumKey];
        if (tariffType === undefined) { return undefined; }
        return tariffList.find(tariff => tariff.tariffType === tariffType) ?? tariffList[0];
    }

    getAiTariffs(): Observable<GetAITariffProductsResponse> {
        return this.protoService.get(
            '/services/products/ai-tariffs'
        ).pipe(
            map(response => {
                return GetAITariffProductsResponse.decode(response);
            })
        );
    }

    changeOwnAITariffOrder(req: CreateOrderRequest, applianceId: string): Observable<SaleOrder> {
        return this.protoService.postJSON<any>(
            `/services/workflow/one/appliance/${applianceId}/ai-tariff/change`,
            CreateOrderRequest.encode(req),
        ).pipe(
            map(r => {
                return this.saleOrderService.prepareSaleOrder(r);
            })
        );
    }

    changeAITariffOrderAsPartner(req: CreateOrderRequest, applianceId: string): Observable<SaleOrder> {
        return this.protoService.postJSON<any>(
            `/services/workflow/partner/one/appliance/${applianceId}/ai-tariff/change`,
            CreateOrderRequest.encode(req),
        ).pipe(
            map(r => {
                return this.saleOrderService.prepareSaleOrder(r);
            })
        );
    }

    changeCspAITariffOrder(req: CreateOrderRequest, applianceId: string): Observable<SaleOrder> {
        return this.protoService.postJSON<any>(
            `/services/workflow/csp/one/appliance/${applianceId}/ai-tariff/change`,
            CreateOrderRequest.encode(req),
        ).pipe(
            map(r => {
                return this.saleOrderService.prepareSaleOrder(r);
            })
        );
    }

}